import dynamic from 'next/dynamic';
import type { Step } from '../flows';
export const pi: Step[] = [{
  step: 'stylist-connect',
  screenViewEvent: {
    name: 'stylist_connect_feature'
  },
  Component: dynamic(() => import('../../StylistConnect/StylistConnect').then(module => module.StylistConnect), {
    ssr: false
  })
}, {
  step: 'stylist',
  screenViewEvent: {
    name: 'stylist'
  },
  Component: dynamic(() => import('../../Stylist/Stylist').then(module => module.Stylist), {
    ssr: false
  })
}, {
  step: 'vision',
  screenViewEvent: {
    name: 'vision_feature'
  },
  Component: dynamic(() => import('../../Vision/Vision').then(module => module.Vision), {
    ssr: false
  })
}, {
  step: 'wrapping-up',
  screenViewEvent: {
    name: 'wrapping_up'
  },
  Component: dynamic(() => import('../../WrappingUp/WrappingUp').then(module => module.WrappingUp), {
    ssr: false
  }),
  bgColor: 'mint',
  navBgColor: 'mint'
}, {
  step: 'summary',
  screenViewEvent: {
    name: 'fix_summary'
  },
  Component: dynamic(() => import('../../Summary/Summary').then(module => module.Summary), {
    ssr: false
  })
}, {
  step: 'payment',
  screenViewEvent: {
    name: 'consolidated_shipping_payment'
  },
  gutter: 'narrow',
  Component: dynamic(() => import('../../ShippingPaymentConsolidated/ShippingPaymentConsolidated').then(module => module.ShippingPaymentConsolidated), {
    ssr: false
  }),
  showNavTitle: true
}, {
  step: 'finalize',
  screenViewEvent: {
    name: 'confirm_first_fix'
  },
  Component: dynamic(() => import('../../Finalize/Finalize').then(module => module.Finalize), {
    ssr: false
  }),
  hideNav: true,
  bgColor: 'mint',
  navBgColor: 'mint'
}];